import CircularProgress from '@mui/material/CircularProgress';

import { CheckCircleIcon } from '@/shared/assets/icons/check-circle-icon';
import { ExclamationCircleIcon } from '@/shared/assets/icons/exclamation-circle-icon';
import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { XCircleIcon } from '@/shared/assets/icons/x-circle-icon';
import { StyledToastContainer } from '@/shared/components/ui/toast/toast.styled';

export const Toast = () => {
  return (
    <StyledToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={4}
      icon={({ type }) => {
        switch (type) {
          case 'info':
            return <InfoIcon variant="info" />;
          case 'success':
            return <CheckCircleIcon variant="success" />;
          case 'error':
            return <XCircleIcon variant="error" />;
          case 'warning':
            return <ExclamationCircleIcon variant="warning" />;
          case 'default':
            return <CircularProgress size="1.25rem" />;
          default:
            return null;
        }
      }}
    />
  );
};
